import { useSPKCookie } from '@portals/forms/src/hooks/useSPKCookie/useSPKCookie';
import { ConfigProvider } from '@portals/sip-client-data/src/general/Config';
import { useEffect, useState } from 'react';

const cockpitBankCodeWhiteList: Record<string, string> = {
  '50050201': 'www.frankfurter-sparkasse.de',
  '37050299': 'www.ksk-koeln.de',
  '39050000': 'www.sparkasse-aachen.de',
  '54050220': 'www.sparkasse-kl.de',
  '37050198': 'www.sparkasse-koelnbonn.de',
  '24151235': 'www.spk-row-ohz.de',
  '74351430': 'www.sparkasse-rottal-inn.de',
  '22250020': 'www.spk-westholstein.de',
  '52050353': 'www.kasseler-sparkasse.de',
  '47853520': 'www.kskhwd.de',
  '57650010': 'www.kskmayen.de',
  '28350000': 'www.sparkasse-aurich-norden.de',
  '38450000': 'www.sparkasse-gm.de',
  '50650023': 'www.sparkasse-hanau.de',
  '57050120': 'www.sparkasse-koblenz.de',
  '81053272': 'www.sparkasse-magdeburg.de',
  '73050000': 'www.sparkasse-neu-ulm-illertissen.de',
  '74050000': 'www.sparkasse-passau.de',
  '67050505': 'www.sparkasse-rhein-neckar-nord.de',
  '46053480': 'www.sparkasse-wittgenstein.de',
  '31050000': 'www.sparkasse-moenchengladbach.de',
};

type Return = {
  isCockpitAccessEnabled: boolean;
  bankCodeUrl: string | null;
};

export const useCockpitAccess = (): Return => {
  const { bankCode } = useSPKCookie();
  const [mounted, setMounted] = useState(false);
  const useImmobilienApi = ConfigProvider.getConfig().get('USE_IMMOBILIEN_API') === 'true';

  useEffect(() => {
    if (useImmobilienApi) {
      setMounted(true);
    }
  }, [useImmobilienApi]);

  const isCockpitAccessEnabled = mounted && Boolean(bankCode) && bankCode in cockpitBankCodeWhiteList;

  const bankCodeUrl = isCockpitAccessEnabled ? `https://${cockpitBankCodeWhiteList[bankCode]}` : null;

  return { isCockpitAccessEnabled, bankCodeUrl };
};
